shadow$provide[305] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Cartesian4:{enumerable:true, get:function() {
  return Cartesian4;
}}});
var require$_DOT__SLASH_view_DOT_js = require("./view.js");
class Cartesian4 extends require$_DOT__SLASH_view_DOT_js.View {
  static initClass() {
    this.traits = ["node", "object", "visible", "view", "view4", "vertex"];
  }
  make() {
    super.make();
    this.uniforms = {basisOffset:this._attributes.make(this._types.vec4()), basisScale:this._attributes.make(this._types.vec4()),};
    this.basisScale = this.uniforms.basisScale.value;
    return this.basisOffset = this.uniforms.basisOffset.value;
  }
  unmake() {
    super.unmake();
    delete this.basisScale;
    delete this.basisOffset;
    return delete this.uniforms;
  }
  change(changed, touched, init) {
    if (!touched["view"] && !touched["view4"] && !init) {
      return;
    }
    const p = this.props.position;
    const s = this.props.scale;
    const g = this.props.range;
    const {x} = g[0];
    const y = g[1].x;
    const z = g[2].x;
    const w = g[3].x;
    const dx = g[0].y - x || 1;
    const dy = g[1].y - y || 1;
    const dz = g[2].y - z || 1;
    const dw = g[3].y - w || 1;
    const mult = function(a, b) {
      a.x *= b.x;
      a.y *= b.y;
      a.z *= b.z;
      return a.w *= b.w;
    };
    this.basisScale.set(2 / dx, 2 / dy, 2 / dz, 2 / dw);
    this.basisOffset.set(-(2 * x + dx) / dx, -(2 * y + dy) / dy, -(2 * z + dz) / dz, -(2 * w + dw) / dw);
    mult(this.basisScale, s);
    mult(this.basisOffset, s);
    this.basisOffset.add(p);
    if (changed["view.range"]) {
      return this.trigger({type:"view.range",});
    }
  }
  vertex(shader, pass) {
    if (pass === 1) {
      shader.pipe("cartesian4.position", this.uniforms);
    }
    return super.vertex(shader, pass);
  }
}
Cartesian4.initClass();

};